module.exports = __webpack_public_path__ + "assets/img/ic-reload.92ab93ab.svg";